import React, { MouseEventHandler } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { BlockLink, UtilsBlock, Text, Image } from '@hz-design-system/web-ui';

import Classes from './ContentArticle.module.scss';
import { TContentItem } from 'types/TContentArticles';

type TContentArticleProps = {
  item: TContentItem;
  smallVariant: boolean;
  eagerLoadImage: boolean;
  onClick: MouseEventHandler<HTMLElement>;
};

const ContentArticles = ({ item, smallVariant, eagerLoadImage, onClick }: TContentArticleProps) => {
  const { t } = useI18nContext();
  return (
    <BlockLink
      key={item.key}
      className={`${Classes.item} ${smallVariant ? Classes.smallItem : ''}`}
      onClick={onClick}
      {...(item.link ? { href: item.link } : {})}
    >
      <article className={Classes.root}>
        <Image
          className={Classes.itemImage}
          src={item.images[1]}
          alt={t(`cars.content.items.${item.key}.alt`)}
          srcSet={`${item.images[0]} 180w, ${item.images[1]} 360w`}
          loading={eagerLoadImage ? 'eager' : 'lazy'}
          fetchpriority={eagerLoadImage ? 'high' : 'low'}
          decoding="async"
          //@ts-expect-error -- DS issue
          aspectRatio=""
        />
        <UtilsBlock className={Classes.itemText} pt="xs">
          <Text.Regular as="strong">{t(`cars.content.items.${item.key}.title`)}</Text.Regular>
          <div className={`hz-Link ${Classes.itemLink}`}>
            {t(`cars.content.items.${item.key}.action`, { count: item.data?.count })}
          </div>
        </UtilsBlock>
      </article>
    </BlockLink>
  );
};

export default ContentArticles;
